import { render, staticRenderFns } from "./MenuItem.vue?vue&type=template&id=1132e4f3&scoped=true"
import script from "./MenuItem.vue?vue&type=script&lang=js"
export * from "./MenuItem.vue?vue&type=script&lang=js"
import style0 from "@/styles/components/MenuItem/MenuItem.less?vue&type=style&index=0&id=1132e4f3&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1132e4f3",
  null
  
)

export default component.exports